import { PDF_APPLICATION, THIRD_PARTY_URL, PREDICTIVE_PROFILES } from './constants'

export const isThirdPartyUrl = (localStoreOpportunitiesMode) =>
  localStoreOpportunitiesMode === PDF_APPLICATION ||
  localStoreOpportunitiesMode === THIRD_PARTY_URL ||
  localStoreOpportunitiesMode === PREDICTIVE_PROFILES

export const getEmailUrl = ({ resourceUrl, storeNumber }) =>
  `mailto:${resourceUrl}?subject=Apply for employment – ${storeNumber}`

export const getEmptyPDFText = ({ email = '' }) =>
  `please email ${email} to request an application`

export const processExternalUrl = (url) => {
  if (url) {
    if (url.indexOf('http') > -1) {
      return url.replace(/https?:\/\//, '//')
    } else if (!(/\/\/|^mailto|^tel/).test(url)) {
      return `//${url}`
    }
  }
  return url
}
